// extracted by mini-css-extract-plugin
export default {"container":"QcCQ0","search":"MQYkw","large":"Nh5cH","side-by-side-mobile":"lwzTN","sideBySideMobile":"lwzTN","userName":"PDP7L","profileLink":"gunig"};